export default __webpack_public_path__ + "static/media/instructions.54e417dc.png";